module.exports = __webpack_public_path__ + "static/media/vokere.64335ff3.jpeg";